<template>
    <div>
        <div class="card" v-if="pagamento.ch_status == 'E'">
            <div class="card-header d-flex justify-content-between">
                <div>
                    <a class="card-link" data-toggle="collapse" href="#collapsePagamento" role="button">
                        PAGAMENTO PENDENTE
                    </a>
                </div>
                <div class="text-right">
                    R$ {{ $util.formatMoeda(pagamento.dc_valor) }}
                </div>
            </div>
            <div class="collapse" id="collapsePagamento">
                <div class="card-body">
                    <div class="row">
                        <div class="col col-12 col-md-6">
                            <az-input
                                type="card"
                                label="Número do Cartão"
                                :validate="validate" 
                                required
                                :rules="['size:16']"
                                v-model="pagamento.st_numero_cartao"/>
                        </div>
                        <div class="col col-12 col-md-2">
                            <az-input
                                type="select"
                                label="Bandeira"
                                :optionsList="[
                                    {id:'Master', search:'Master'},
                                    {id:'Visa', search:'Visa'},
                                ]"
                                optionsData="id"
                                optionsDisplay="search"
                                v-model="pagamento.st_bandeira"
                                required
                                :validate="validate" />
                        </div>
                        <div class="col col-12 col-md-2">
                            <az-input
                                type="mask"
                                mask="###"
                                label="Código de Segurança (CVV)"
                                v-model="pagamento.st_cvv"
                                required
                                :validate="validate" />
                        </div>
                        <div class="col col-12 col-md-2">
                            <az-input
                                type="mask"
                                mask="##/####"
                                label="Validade do Cartão"
                                v-model="pagamento.st_validade"
                                required
                                :validate="validate" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col col-12 col-md-6">
                            <az-input
                                type="text"
                                label="Nome do Titular (Como impresso no cartão)"
                                v-model="pagamento.st_nome_titular"
                                required
                                :validate="validate" />
                        </div>
                        <div class="col col-12 col-md-4">
                            <az-input
                                type="cpf"
                                label="CPF"
                                v-model="pagamento.st_cpf"
                                required
                                :validate="validate" />
                        </div>
                        <div class="col col-12 col-md-2">
                            <az-input
                                type="select"
                                label="Número de Parcelas"
                                :optionsList="[
                                    {id: 1, search:'1'},
                                    {id: 2, search:'2'},
                                    {id: 3, search:'3'},
                                ]"
                                optionsData="id"
                                optionsDisplay="search"
                                v-model="pagamento.in_numero_parcelas"
                                required
                                :validate="validate" />
                        </div>
                        <div class="col col-4" v-if="false">
                            <small class="text-muted text-truncate text-nowrap">Utilize meu endereço como endereço de cobrança</small>
                            <az-input
                                type="checkbox-group"
                                label="Utilizar."
                                v-model="pagamento.fl_endereco_cadastro" />
                        </div>
                    </div>
                    <div class="mt-3" v-if="false && !pagamento.fl_endereco_cadastro" >
                        <az-sub-title title="Endereço de Cobrança" />
                        <cadastro-endereco v-model="pagamento.endereco" />
                    </div>
                </div>
                <div class="card-footer">
                    <az-submit @click="pagar()">Realizar Pagamento</az-submit>
                </div>
            </div>
        </div>

        
        <div class="card" v-else-if="pagamento && pagamento.status_pagamento">
            <div class="card-header d-flex justify-content-between">
                <div>
                    <a class="card-link" data-toggle="collapse" href="#collapsePagamento" role="button">
                        {{ pagamento.status_pagamento.toUpperCase() }} 
                    </a>
                </div>
                <div class="text-right">
                    <i class="fa fa-check text-success ml-2" aria-hidden="true"></i>
                </div>
            </div>
            <div class="collapse" id="collapsePagamento">
                <div class="card-body" v-if="pagamento.js_resposta">
                    <div>Valor: R$ {{ $util.formatMoeda(pagamento.dc_valor) }}</div>
                    <div>Tipo: {{ pagamento.js_resposta.Payment.Type }}</div>
                    <div>Id do Pagamento: {{ pagamento.js_resposta.Payment.PaymentId }}</div>
                    <div>Código de Autorização: {{ pagamento.js_resposta.Payment.AuthorizationCode }}</div>
                </div>
            </div>
        </div>

        <template v-if="retorno">
            <p class="alert" 
                :class="retorno.payment.status == 1 || retorno.payment.status == 2 ? 'alert-success' : 'alert-warning'" 
                v-if="retorno.payment">
                {{ retorno.payment.returnMessage }}
            </p>

            <img :src="'data:image/jpeg;charset=utf-8;base64,' + retorno.Payment.QrCodeBase64Image" />

            <p>{{ retorno.Payment.QrCodeBase64Image }}</p>

            <pre class="alert alert-info mt-3">{{ retorno }}</pre>

        </template>
    </div>
</template>

<script>
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import CadastroEndereco from '../../shared/CadastroEndereco.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() { 
        return { 
            validate: false,
            meu_endereco: true,
            pagamento: { 
                st_numero_cartao: "",
                st_cvv: "",
                st_validade: "",
                st_nome_titular: "",
                fl_endereco_cadastro: true, 
                st_bandeira: "",
                in_numero_parcelas: 1, 
                st_cpf: "", 
                endereco: { 
                    cidade: {} 
                }
            },
            retorno: null, 
        }
    },

    components: { 
        AzInput,
        AzSubTitle,
        AzSubmit, 
        CadastroEndereco, 
    },

    props: ['value', 'marcacao', 'domain', 'token', 'action'],
    
    methods: { 
        pagar() { 

            $('[data-toggle="tooltip"]').tooltip("dispose");

            this.validate = true;

            this.$nextTick(() => {

                let invalids = $('#collapsePagamento .invalid');

                if (invalids.length && $(".invalid").is(":visible")) {

                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Verificar preenchimento dos campos.",
                        life: 3000
                    });

                    return;

                }

                this.$store.commit('loading', true);

                this.axios.post('portal/pagamento', { 
                        d: this.domain,
                        m: this.marcacao.id_marcacao,
                        t: this.token,
                        dados: this.pagamento, 
                    })
                    .then(res => { 
                        if ( res.response && res.response.status >= 400 ) { 

                            // 

                        } else {
                            
                            this.pagamento.ch_status = 'P';
                            this.pagamento.status_pagamento = 'Pagamento Realizado';
                            this.pagamento.js_resposta = null;

                            this.$toast.add({
                                severity: "success",
                                summary: "Atenção",
                                detail: "Atualização realizada com sucesso.",
                                life: 3000
                            });

                            this.$nextTick(() => { 
                                $('#collapsePagamento').collapse('hide');
                            });

                            this.$emit('refresh');

                        }
                    })
                    .finally(() => { 
                        this.$store.commit('loading', false);
                    });
            
            });

        },

        pagar2() { 
            this.$util.atualizar(this, { 
                service: 'pagamentos_online',
                func: 'store',
                dados: this.pagamento,
                toast: true, 
                callback: res => { 
                    this.retorno = res;
                    console.log(res);
                }
            });
        },

        qrcode() { 
            this.$util.atualizar(this, { 
                service: 'pagamentos_online',
                func: 'qrcode',
                dados: this.pagamento,
                toast: true, 
                callback: res => { 
                    this.retorno = res;
                    console.log(res);
                }
            });
        },
    },

    mounted() { 
        this.pagamento = this.value;

        this.$nextTick(() => { 
            if ( this.pagamento && this.pagamento.ch_status == 'E' ) { 
                if ( this.action != 'canc' )
                    $('#collapsePagamento').collapse('show');
            }
        });
    }
}
</script>